export default "__VITE_ASSET__13e59311__"